<template>
    <div class="heroImageSection">
        <div v-if="loading">
            <Spinner size="large" message="Loading..." line-fg-color="#000" style="padding: 5rem 0;"/>
        </div>
        <vueper-slides 
            fade
            autoplay
            :arrows="false"
            :bullets="false"
            :touchable="false"
            fixed-height="100%"
            :pauseOnHover="false"
            style="margin-top:-47px;">
            <vueper-slide
                v-for="(slide, i) in slides"
                :key="i"
                :image="slide"
                class="heroImageSlide">
                <template v-slot:content>
                </template>
            </vueper-slide>
        </vueper-slides>
    </div>
</template>

<script>
import { VueperSlides, VueperSlide } from 'vueperslides'
import Spinner from 'vue-simple-spinner'

export default {
    name: "HeroSlideshow",
    components: { VueperSlides, VueperSlide, Spinner },
    data() {
        return {
            loading: false,
            slides: [
                '/images/minnesota-pr-001.jpg',
                '/images/minnesota-pr-002.jpg',
                '/images/minnesota-pr-003.jpg',
                '/images/minnesota-pr-004.jpg',
                '/images/minnesota-pr-005.jpg',
                '/images/minnesota-pr-006.jpg',
                '/images/minnesota-pr-007.jpg',
                '/images/minnesota-pr-008.jpg',
                '/images/minnesota-pr-009.jpg',
                '/images/minnesota-pr-010.jpg',
            ]
        }
    },
}
</script>

<style lang="scss" scoped>
.heroImageSection{
    width: 100%;
    height: calc(100vh - 117px);
    background: #000;
}
@media (max-width: $mobile) {
    .heroImageSection{
        height: 100vh;
    }
}
</style>

<style >
.heroImageSlide .slideContent{
    top: unset !important;
    left: unset !important;
    transform: unset !important;
    width: 100%;
    height: 100%;
    text-align: center;
}

.heroImageSlide .slideContent p{
    right: 4rem;
    bottom: 2rem;
    position: absolute;
}

.vueperslides--fade .vueperslide{
    transition: 1.5s ease-in-out;
}
.underline{
    text-decoration: underline !important;
}

@media (max-width: 576px) { 
    .heroImageSlide .slideContent p{
        display: none;  
    }
}
</style>